import {ActiveField} from '../ActiveField'

export type SelectFieldValuesHandler = (scope: any, rootScope: any, formScope: any) => SelectValue[]

export interface SelectValue {
  label: string,
  value: string | number
}

export interface SelectFieldOptions {
  values: SelectFieldValuesHandler | SelectValue[]
}

export default class SelectField extends ActiveField {
  constructor () {
    // @ts-ignore
    super(...arguments)
    this.fieldType = 'select'
  }

  public isEmpty (value: any): boolean {
    return value === undefined || value === '' || value === null
  }
}